import React from 'react'
import { Tab } from '@softura/fluentuipackage'
import './Tabs.scss'

interface IProps {
  className?: string,
  linkFormat?: string,
  tabItems?: any
}

const Tabs = ({ linkFormat, tabItems, className }:IProps) => {

  return <div className='pivot'>
    <Tab
      className = {`custom-tab ${className}`}
      linkFormat = {linkFormat}
      tabItems = {tabItems}
    />
  </div>
}

export default Tabs
